import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { ApiService } from '../../service/api_service'
import * as XLSX from 'xlsx';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-campaigns',
    template: require('./campaigns.component.html'),
    styles: []
})
export class CampaignsComponent implements OnInit {
    api: any;
    busy: Subscription;
    defaultColDefine;
    CampaignList: any = [];
    private gridColumnApi;
    private columnDefs;
    private rowData;
    private rowHeight;
    static parameters = [Router, HttpClient];
    constructor(private router: Router, private http: HttpClient) {
        let parent = this;
        this.columnDefs = [
            {
                headerName: 'Action', field: 'action', width : 100 , pinned: 'left', cellRenderer: function (params) {

                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = `
                        <a class="editBtn" href="javascript: void(0)"><i class="icon-edit"></i></a>
                    `;
                    var editButton = eDiv.querySelectorAll('.editBtn')[0];
                    editButton.addEventListener('click', function () {
                        parent.router.navigate(['/addcampaign'], { queryParams: { id: params.data.Campaigns_ID } });
                        //self.router.navigate(['/arealistmaster'], { queryParams: { id: params.data.HQID } });
                    });
                    return eDiv
                }
            },
            { headerName: 'Campaign Name', field: 'Campaigns_name' },
            { headerName: 'Product', field: 'ProductName',width : 350 },
            { headerName: 'Start Date', field: 'StartDate' },
            { headerName: 'End Date', field: 'EndDate' },
            { headerName: 'State', field: 'StateID' },
            { headerName: 'Status', field: 'status' },
        ];
        this.defaultColDefine = { resizable: true };
        this.rowHeight = 50;
    }

    ngOnInit() {
        this.GetCampaignDetails();
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
      }

      onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'Campaign_Master' });
      }

    onGridReady(params) {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    GetCampaignDetails() {
        this.busy = this.http.post('/api/admin/GetCampaignDetails',{}).subscribe((res: any) => {
            console.log(res);
            this.CampaignList = res.data;
        });
    }
}
